export function contentCategoryId(category: string): string {
  return `category-${category
    .toLowerCase()
    .replace(/[^a-z0-9]+/gu, '-')
    .replace(/^-|-$/gu, '')}`;
}

export const CONTENT_CATEGORY_ORDER: readonly string[] = [
  'IQ essentials',
  'IQ score interpretation',
  'Famous people and IQ claims',
  'Practice questions',
  'Interactive tools',
  'Brain training',
  'IQ statistics',
  'Science of testing',
  'IQ questions answered',
  'Comparisons',
  'Research explainers',
];
